import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import { BaasicFieldDropdown, DatePickerField, BasicFileInput } from 'core/components';
import { ApplicationEditLayout, Content } from "core/layouts";

const FacilityOrderEditTemplateCsv = function({ facilityOrderEditCsvViewStore }) {
	const {
		contentLoading,
		form,
		facilityStore
	} = facilityOrderEditCsvViewStore;

	return (
		<ApplicationEditLayout store={facilityOrderEditCsvViewStore}>
			<Content loading={contentLoading}>
				<React.Fragment>					
					<div className="row">
						<div className="col col-sml-10 col-lrg-8">
							<div className="card card--form card--primary card--med">
								<div className="row">
									<div className="form__group col col-lrg-6 u-mar--bottom--sml">
										<BasicFileInput field={form.$('file')} />
									</div>    
								</div>
								<div className="row">
									<div className="form__group col col-lrg-6 u-mar--bottom--sml">
										<BaasicFieldDropdown field={form.$('facilityId')} store={facilityStore}/>
									</div>
									<div className="form__group col col-lrg-6 u-mar--bottom--sml">
										<DatePickerField field={form.$('dateOfService')} />
									</div>
								</div>
							</div>
						</div>
					</div>
				</React.Fragment>
			</Content>
		</ApplicationEditLayout>
	);
};

FacilityOrderEditTemplateCsv.propTypes = {
	facilityOrderEditCsvViewStore: PropTypes.object.isRequired,
	t: PropTypes.func,
};

export default defaultTemplate(FacilityOrderEditTemplateCsv);